import { Redirect, router } from 'expo-router';
import { useState } from 'react';
import { ScreenContainer, Spinner, useToastController, YStack } from 'smoothie';

import PaymentMethodDeleteSheet from '../../../billing/components/PaymentMethodDeleteSheet';
import PaymentMethodSection from '../../../billing/components/PaymentMethodSection';
import { useGetPaymentMethod } from '../../../billing/hooks/usePaymentMethod';
import {
    SUCCESS_TOAST_DURATION,
    SuccessToastIcon,
} from '../../../member-profile/components/SuccessToast';
import { useUser } from '../../../user/providers/UserProvider';

// Throwaway POC screen: mirrors the Figma "Billing" payment-method screen's
// content/functionality (add / change / remove), not its exact visual design.
export default function PaymentMethodPage() {
    if (
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'local' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'sandbox' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'staging'
    ) {
        return <Redirect href="/" />;
    }

    const toast = useToastController();
    const [isDeleteSheetOpen, setIsDeleteSheetOpen] = useState(false);

    const { user, loading: isLoadingUser } = useUser();
    const {
        data: paymentMethod,
        isLoading: isLoadingPaymentMethod,
        refetch: refetchPaymentMethod,
    } = useGetPaymentMethod(
        { userId: user?.id ?? '' },
        { enabled: user?.id != null },
    );

    return (
        <ScreenContainer title="Billing" hasBackButton onFallbackRoute="/dev">
            {isLoadingUser || isLoadingPaymentMethod ? (
                <Spinner />
            ) : (
                <YStack gap={16} padding={16} width="100%">
                    <PaymentMethodSection
                        paymentMethod={paymentMethod ?? null}
                        onPressAdd={() => {
                            router.push('/dev/stripe/payment-method-add');
                        }}
                        onPressChange={() => {
                            router.push('/dev/stripe/payment-method-change');
                        }}
                        onPressDelete={() => {
                            setIsDeleteSheetOpen(true);
                        }}
                    />
                </YStack>
            )}
            <PaymentMethodDeleteSheet
                isOpen={isDeleteSheetOpen}
                paymentMethod={paymentMethod ?? null}
                onClose={() => {
                    setIsDeleteSheetOpen(false);
                }}
                onDeleted={() => {
                    setIsDeleteSheetOpen(false);
                    void refetchPaymentMethod();
                    toast.show('Payment method deleted', {
                        duration: SUCCESS_TOAST_DURATION,
                        icon: SuccessToastIcon,
                    });
                }}
            />
        </ScreenContainer>
    );
}
